import { API_ENDPOINTS } from '@config/api.config';

export const GET_SERVER_FILE_INFO_API =
  API_ENDPOINTS.auth + '/get-list';
